import { Euro, X } from 'lucide-react';
import { format, parseISO } from 'date-fns';
import { pt } from 'date-fns/locale';
import type { HistoricoMesa, MapaMesa } from '../../types';

function origemLabel(origem: number) {
  return origem === 10 ? 'Reserva' : origem === 1 ? 'Ocupação' : 'Normal';
}

function dataMesaLabel(value: string) {
  try {
    return format(parseISO(value), 'dd/MM/yyyy HH:mm', { locale: pt });
  } catch {
    return value || '—';
  }
}

interface EditarOcupacaoModalProps {
  mesa: MapaMesa | null;
  historico: HistoricoMesa;
  onChange: (h: HistoricoMesa) => void;
  onClose: () => void;
  onSubmit: (e: React.FormEvent) => void;
}

export function EditarOcupacaoModal({ mesa, historico, onChange, onClose, onSubmit }: EditarOcupacaoModalProps) {
  return (
    <div className="modal-overlay" role="dialog" aria-modal="true" aria-labelledby="edit-historico-title">
      <div className="modal">
        <header className="modal-header">
          <h2 id="edit-historico-title" className="modal-title">
            Editar Ocupação — Mesa {mesa?.numero}
          </h2>
          <button className="modal-close" onClick={onClose} aria-label="Fechar">
            <X className="w-5 h-5" />
          </button>
        </header>
        <form id="edit-historico-form" onSubmit={onSubmit} className="modal-body">
          <div className="form-row" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, alignItems: 'end' }}>
            <div className="form-group" style={{ marginBottom: 0 }}>
              <label className="label" style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                Nº pessoas *
              </label>
              <input
                type="number"
                className="input"
                value={historico.numeroPessoas}
                onChange={(e) => onChange({ ...historico, numeroPessoas: Number(e.target.value) || 1 })}
                min={1}
                max={20}
                required
              />
            </div>
            <div className="form-group" style={{ marginBottom: 0 }}>
              <label className="label" style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                <Euro className="w-4 h-4" />
                Valor (€)
              </label>
              <input
                type="number"
                className="input"
                value={historico.valor}
                onChange={(e) => onChange({ ...historico, valor: Number(e.target.value) || 0 })}
                min={0}
                step={0.01}
                placeholder="0.00"
              />
            </div>
          </div>
          <div className="form-row" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, alignItems: 'end' }}>
            <div className="form-group" style={{ marginBottom: 0 }}>
              <label className="label">Origem (só leitura)</label>
              <span className="badge badge-neutral" style={{ alignSelf: 'flex-start' }}>{origemLabel(historico.origem)}</span>
            </div>
            <div className="form-group" style={{ marginBottom: 0 }}>
              <label className="label">Data da mesa (só leitura)</label>
              <input className="input" value={dataMesaLabel(historico.dataMesa)} disabled readOnly />
            </div>
          </div>
          <div className="form-group form-checkbox">
            <label className="checkbox-label">
              <input
                type="checkbox"
                checked={historico.pago}
                onChange={(e) => onChange({ ...historico, pago: e.target.checked })}
              />
              <span>Pago</span>
            </label>
          </div>
          <div className="form-group">
            <label className="label">Contacto</label>
            <input
              className="input"
              value={historico.contatoReserva || ''}
              onChange={(e) => onChange({ ...historico, contatoReserva: e.target.value })}
              placeholder="Telefone"
            />
          </div>
          <div className="form-group">
            <label className="label">Notas</label>
            <textarea
              className="input"
              rows={2}
              value={historico.notasMesa || ''}
              onChange={(e) => onChange({ ...historico, notasMesa: e.target.value })}
              placeholder="Observações"
            />
          </div>
        </form>
        <footer className="modal-footer">
          <button className="btn btn-secondary" onClick={onClose}>
            Cancelar
          </button>
          <button className="btn btn-primary" type="submit" form="edit-historico-form">
            Guardar
          </button>
        </footer>
      </div>
    </div>
  );
}
